import { Sparkle } from "lucide-react";
import { MARQUEE } from "./data";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {[...MARQUEE, ...MARQUEE].map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-3xl font-medium uppercase tracking-[0.08em] text-ns-ivory sm:text-4xl md:text-5xl">
          {i % 2 ? <em className="italic text-ns-goldlt">{t}</em> : t}
        </span>
        <Sparkle className="h-6 w-6 shrink-0 fill-ns-gold text-ns-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="quality-marquee" className="relative overflow-hidden border-y border-ns-gold/30 bg-ns-emerald py-7 sm:py-9">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
